
import { Step } from "@/lib/types";

export const createTiktokStep: Step = {
  id: "create-tiktok",
  type: "multiStep",
  title: "Day 0: Create the Tiktok Account",
  description: "Information: the username should be craycrayapp01. If craycrayapp01 is not available, change the number at the end.",
  buttonText: "Continue",
  subSteps: [
    {
      id: "create",
      title: "Create TikTok Account",
      description: "Follow these steps to create your TikTok account.",
      buttonText: "I've Created My Account",
      todos: [
        {
          id: "download-tiktok",
          text: "Download Tiktok",
          completed: false
        },
        {
          id: "create-account",
          text: "Create a brand new account using your phone number or email",
          completed: false
        },
        {
          id: "verify-account",
          text: "Verify the phone number / email if requested by tiktok",
          completed: false
        },
        {
          id: "account-created",
          text: "I created the account",
          completed: false
        }
      ],
      inputs: [
        {
          name: "username",
          type: "text",
          label: "TikTok Username",
          placeholder: "Enter your TikTok username (e.g. @craycrayapp01)"
        }
      ]
    }
  ]
};
